import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=2246e971&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=2246e971&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2246e971",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2246e971')) {
      api.createRecord('2246e971', component.options)
    } else {
      api.reload('2246e971', component.options)
    }
    module.hot.accept("./userDetails.vue?vue&type=template&id=2246e971&scoped=true", function () {
      api.rerender('2246e971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/userDetails.vue"
export default component.exports